/**
 * Aree e azioni dei ruoli, lato web.
 *
 * [sc-48351 / task 48786] Gemello di `crmstart-api/src/config/roles.js`: le
 * caselle che la pagina Ruoli mostra accese devono essere quelle che l'API
 * accetta. Le etichette stanno solo qui: sono testo per chi legge.
 */

export const AREE = Object.freeze([
  "dashboard",
  "statistiche",
  "clienti",
  "listini",
  "preventivi",
  "ordini",
  "ddt",
  "fatture",
  "magazzino",
]);

export const AZIONI = Object.freeze(["V", "C", "M", "E", "A", "X"]);

/**
 * Il ruolo con tutti i permessi (`operators.isAdmin`). «Admin» e non
 * «Amministratore», che accanto ad «Amministrazione» si confondeva. Gemello
 * di `NOME_AMMINISTRATORE` nell'API.
 */
export const NOME_ADMIN = "Admin";

export const CASELLE = Object.freeze({
  dashboard: ["V"],
  statistiche: ["V"],
  clienti: ["V", "C", "M", "E"],
  listini: ["V", "C", "M", "E"],
  preventivi: ["V", "C", "M", "E", "A", "X"],
  ordini: ["V", "M", "E", "X"],
  ddt: ["V", "C", "X"],
  // [sc-48139] C = emettere, verificare, reinviare; X = scaricare PDF e XML.
  fatture: ["V", "C", "X"],
  magazzino: ["V", "M"],
});

export const ETICHETTE_AREE = Object.freeze({
  dashboard: "Dashboard",
  statistiche: "Statistiche",
  clienti: "Clienti",
  listini: "Listini",
  preventivi: "Preventivi",
  ordini: "Ordini",
  ddt: "DDT",
  fatture: "Fatture",
  magazzino: "Magazzino",
});

export const ETICHETTE_AZIONI = Object.freeze({
  V: "Vedere",
  C: "Creare",
  M: "Modificare",
  E: "Eliminare",
  A: "Approvare",
  X: "Esportare",
});

export function puo(permessi, area, azione) {
  if (!permessi) return false;
  if (permessi.isAdmin) return true;
  return Boolean(permessi.grid?.[area]?.includes(azione));
}
